

import axios from '../axiosCall'
import Urls from "../endpoints";
import { IRequestToggleCustomerStatus, IResponseGetCustomerStatus, IResponseGetUrl, IResponseOfGet, IchangeStatus, IgetDetectedSensitiveWordLog } from '../modelAPI/detectedSensitiveWordLog';




export const getDetectedSensitiveWordLog = (params:IgetDetectedSensitiveWordLog) => {
    return axios.post<IResponseOfGet>(Urls.DetectedSensitiveWordLog(), params)
}

export const changeState = (params:IchangeStatus) => {
    return axios.post<boolean|string>(Urls.ChangeState(), params)
}

export const getUrlLink=(url:string)=>{
    return axios.get<IResponseGetUrl>(Urls.GetURLLink(url))
}

export const getCustomerStatus=(id:string)=>{
    return axios.get<IResponseGetCustomerStatus>(Urls.GetCustomerStatus(id))
}

export const toggleCustomerStatus=(params:IRequestToggleCustomerStatus)=>{
    return axios.post<string>(Urls.ToggleCustomerStatus(),params)
}